import React from "react";

import { NavBar } from "./organisms/NavBar";

export const Layout = () => {
  return <NavBar />;
};
